import React from "react";

function Video1() {
  return (
    <div>
      <div className="video section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 offset-lg-4">
              <div className="section-heading text-center">
                <h6>| Video View</h6>
                <h2>Get Closer View &amp; Different Feeling</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Video1;
